// extracted by mini-css-extract-plugin
export var social = "bD_d8";